import { useTranslation } from 'react-i18next';
import { Gavel, User, Phone, Mail, Home } from 'lucide-react';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { InfoField } from '@/components/common/InfoField';
import type { Matter } from '../types';

interface MatterCardProps {
  matter: Matter;
}

export function CourtInfoCard({ matter }: MatterCardProps) {
  const { t } = useTranslation();
  if (!matter.isCourtCase) return null;

  return (
    <Card className="bg-white border-slate-200 shadow-sm hover:shadow-md transition-shadow">
      <CardHeader className="pb-3 border-b border-slate-100">
        <CardTitle className="text-lg font-semibold text-slate-900 flex items-center gap-2">
          <Gavel className="h-5 w-5 text-slate-400" />
          {t('courtInformation')}
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-4 space-y-4">
        <InfoField
          icon={Home}
          label={t('courtName')}
          value={matter.courtName}
        />
        <InfoField
          icon={Phone}
          label={t('courtPhone')}
          value={matter.courtPhone}
          href={matter.courtPhone ? `tel:${matter.courtPhone}` : undefined}
        />
        <InfoField
          icon={Mail}
          label={t('courtEmail')}
          value={matter.courtEmail}
          href={matter.courtEmail ? `mailto:${matter.courtEmail}` : undefined}
        />
        <InfoField
          icon={User}
          label={t('judge')}
          value={matter.judgeName}
        />
      </CardContent>
    </Card>
  );
}

// Case 360° (Stage 14 redesign): MatterOverviewCard, MatterSystemInfoCard,
// MatterClientCard, MatterContractCard, TeamCard and MatterQuickActionsCard
// were retired — the Overview tab is MatterOverviewPanel (essentials only),
// the team lives in MatterTeamPanel, and quick actions moved into the header.
